import type { FeatureConfigPathCallback } from '@luna/feature-config';
import { getFeatureConfig } from '@luna/feature-config';

/**
 * Type for luna/feature-config.
 */
export type DateConfigType = { base?: { defaultTimezone?: string; defaultDateFormat?: string } };

// @ts-expect-error - order of params
export function getDateFeatureConfig<FeatureConfig = DateConfigType, FeatureConfigReturnType>(
    featureConfigPathCallback: FeatureConfigPathCallback<FeatureConfig, FeatureConfigReturnType>,
): FeatureConfigReturnType {
    return getFeatureConfig(featureConfigPathCallback);
}
